import type { ProductReturn } from '~/api/care-folders/types/product-return'

export function isOneWay(productReturn: ProductReturn) {
  return (
    productReturn.kind === 'CUSTOMER_TO_MERCHANT' ||
    productReturn.kind === 'CUSTOMER_TO_FACTORY'
  )
}
